export function throttle(milissegundos = 700) {

    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {

        const metodoOriginal = descriptor.value;

        let timer = 0;

        descriptor.value = function (...args: any[]) {
            if (event) { event.preventDefault() };
            clearInterval(timer);
            timer = <any>setTimeout(() => metodoOriginal.apply(this, args), milissegundos);

        }

        return descriptor;
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/decorators/throttle.ts